import { lazy } from 'react'
import StaffMembersLoader from './staff-members/loader'
import EditStaffMemberLoader from './staff-members/edit/loader'
import AddStaffMemberLoader from './staff-members/add/loader'
import RequestEmployeeInformationLoader from './staff-members/request/loader'
import UnavailabilityStatusLoader from './staff-members/unavailability/loader'
import LeaveRequestStatusLoader from './staff-members/leave/loader'
import ApprovalsLoader from './approvals/loader'
import ManageRequestLoader from './approvals/manage/loader'
import DocumentsLoader from './documents/loader'
import OnboardingPacksLoader from './onboarding-packs/loader'

export default {
  StaffMembers: {
    Component: lazy(() => import('./staff-members/StaffMembers.Page')),
    Loader: StaffMembersLoader,
  },
  EditStaffMember: {
    Component: lazy(() => import('./staff-members/edit/EditStaffMember.Page')),
    Loader: EditStaffMemberLoader,
  },
  AddStaffMember: {
    Component: lazy(() => import('./staff-members/add/AddStaffMember.Page')),
    Loader: AddStaffMemberLoader,
  },
  RequestEmployeeInformation: {
    Component: lazy(
      () => import('./staff-members/request/RequestEmployeeInformation.Page')
    ),
    Loader: RequestEmployeeInformationLoader,
  },
  UnavailabilityStatus: {
    Component: lazy(() => import('./staff-members/unavailability/Status.Page')),
    Loader: UnavailabilityStatusLoader,
  },
  LeaveRequestStatus: {
    Component: lazy(() => import('./staff-members/leave/Status.Page')),
    Loader: LeaveRequestStatusLoader,
  },
  Approvals: {
    Component: lazy(() => import('./approvals/Approvals.Page')),
    Loader: ApprovalsLoader,
  },
  ManageRequest: {
    Component: lazy(() => import('./approvals/manage/ManageRequest.Page')),
    Loader: ManageRequestLoader,
  },
  Documents: {
    Component: lazy(() => import('./documents/Documents.Page')),
    Loader: DocumentsLoader,
  },
  OnboardingPacks: {
    Component: lazy(() => import('./onboarding-packs/OnboardingPacks.Page')),
    Loader: OnboardingPacksLoader,
  },
}
